"use client";

import { Autoplay, EffectFade, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default function SliderNoTitle({
  images,
  title,
}) {
  return (
    <div>
      <Swiper
        effect={"fade"}
        pagination={{ type: "bullets", clickable: true }}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        loop={true}
        modules={[Autoplay, EffectFade, Pagination]}
      >
        {images.map((s, i) => (
          <SwiperSlide key={i}>
            <div className="w-full h-full">
              <img
                src={s}
                alt={title}
                fill
                className="!relative object-cover w-full h-full aspect-[3/2]"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
